import { registerPlugin } from '@capacitor/core';
const NotificationReader = registerPlugin('NotificationReader', {
    web: () => import('./web').then((m) => new m.NotificationReaderWeb()),
});
export * from './definitions';
export { NotificationReader };
//# sourceMappingURL=index.js.map